import { createReducer, on } from '@ngrx/store';
import {
  CategoryWifiProfilePresetConfigurationApiActions,
  CategoryWifiProfilePresetConfigurationViewActions,
} from './category-wifi-profile-preset-configuration.actions';
import { adapter, initialState, selectId } from './category-wifi-profile-preset-configuration.state';

export const categoryWifiProfilePresetConfigurationReducer = createReducer(
  initialState,
  on(
    CategoryWifiProfilePresetConfigurationApiActions.categoryWifiProfilePresetConfigurationsLoaded,
    (state, { wifiProfiles }) => {
      return adapter.setMany(wifiProfiles, state);
    }
  ),
  on(
    CategoryWifiProfilePresetConfigurationViewActions.wifiProfilePresetConfigurationsUpdated,
    (state, { category, updatedWifiProfilesLinkedToCategory }) => {
      // Clear store for given category and add new profiles
      const intermediateState = adapter.removeMany((x) => selectId(x).includes(category.categoryId), state);
      return adapter.setMany(updatedWifiProfilesLinkedToCategory, intermediateState);
    }
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryWifiProfilePresetConfigurationIds = selectIds;

export const selectCategoryWifiProfilePresetConfigurationEntities = selectEntities;

export const selectAllCategoryWifiProfilePresetConfigurations = selectAll;
